import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataTutorialCategory(params) {
	return client.get("api/tutorial-category/data", {
		params: params,
	});
}

function getDataTutorialCategoryActive(params) {
	return client.get("api/tutorial-category/data-active", {
		params: params,
	});
}

function addTutorialCategory(params) {
	return client.post("api/tutorial-category/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateTutorialCategory(params) {
	return client.post("api/tutorial-category/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteTutorialCategory(params) {
	return client.post("api/tutorial-category/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusTutorialCategory(params) {
	return client.post("api/tutorial-category/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}


export default {
	getDataTutorialCategory,
	getDataTutorialCategoryActive,
	addTutorialCategory,
	updateTutorialCategory,
	deleteTutorialCategory,
	statusTutorialCategory,
};